export function suggestionPromptInputsKey(input: {
  name?: string | null;
  description?: string | null;
  brand?: string | null;
  labels?: string[] | null;
}): string {
  return [
    input.name || '',
    input.description || '',
    input.brand || '',
    [...(input.labels || [])].sort().join('\0'),
  ].join('\0');
}
